import { Action, createReducer, on } from '@ngrx/store';
import { loadedLocalidadesError, loadedLocalidadesSuccess } from './localidad.actions';
import { ILocalidadState, initialLocalidadState } from './localidad.state';

const reducer = createReducer(
	initialLocalidadState,
	on(loadedLocalidadesSuccess, (state, payload) => ({
		...state,
		localidades: payload.localidades,
	})),
	on(loadedLocalidadesError, (state, payload) => ({
		...state,
		errors: payload.error,
	}))
);

export function localidadReducer(state: ILocalidadState = initialLocalidadState, action: Action): ILocalidadState {
	return reducer(state, action);
}
